<template>
  <div class="partnerContainer">
    <Header name="Partner" />
    <div class="partnerContent">
      <h3>Partnerportale regional</h3>
      <div class="partnerListe">
        <a
          rel="noopener noreferrer"
          target="_blank"
          class="partnerItem"
          v-for="partner in regional"
          :key="partner.name"
          :href="partner.url"
        >
          <img :src="partner.img_src">
          <br>
          {{partner.name}}
        </a>
      </div>
      <h3>Partnerportale überregional</h3>
      <div class="partnerListe">
        <a
          rel="noopener noreferrer"
          target="_blank"
          class="partnerItem"
          v-for="partner in ueberregional"
          :key="partner.name"
          :href="partner.url"
        >
          <img :src="partner.img_src">
          <br>
          {{partner.name}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./../CoreComponents/Header.vue";
export default {
  name: "Partneransicht",
  components: { Header },
  data: function() {
    return {
      regional: [
        {
          name: "Deutsche Bahn",
          url: "http://www.deutschebahn.com",
          img_src: require("@/assets/images/partner/deutsche_bahn.png")
        },
        {
          name: "Flughafen Frankfurt",
          url: "http://www.frankfurt-airport.de",
          img_src: require("@/assets/images/partner/frankfurt_airport.png")
        },
        {
          name: "Mainziel",
          url: "http://mainziel.de/",
          img_src: require("@/assets/images/partner/ziel_frankfurt.png")
        },
        {
          name: "Messe Frankfurt",
          url: "http://www.messefrankfurt.com",
          img_src: require("@/assets/images/partner/messe_frankfurt.png")
        },
        {
          name: "Radroutenplaner Hessen",
          url: "http://www.radroutenplaner.hessen.de",
          img_src: require("@/assets/images/partner/radtourenplaner_hessen.png")
        },
        {
          name: "RMV",
          url: "http://www.rmv.de/",
          img_src: require("@/assets/images/partner/rmv.png")
        },
        {
          name: "Vielmobil",
          url: "http://www.vielmobil.info/",
          img_src: require("@/assets/images/partner/vielmobil.png")
        }
      ],
      ueberregional: [
        {
          name: "Verkehrslage Baden Württemberg",
          url: "http://www.svz-bw.de/",
          img_src: require("@/assets/images/partner/baden_wuertemberg.png")
        },
        {
          name: "Verkehrslage Bayern",
          url: "http://www.bayerninfo.de",
          img_src: require("@/assets/images/partner/bayern_info.png")
        },
        {
          name: "Verkehrslage Niedersachsen",
          url: "http://www.vmz-niedersachsen.de",
          img_src: require("@/assets/images/partner/verkehrszentrale_niedersachsen.png")
        },
        {
          name: "Verkehrslage Nordrhein Westfalen",
          url: "http://www.verkehr.nrw.de",
          img_src: require("@/assets/images/partner/verkehr_nrw.png")
        },
        {
          name: "Verkehrslage Rheinland-Pfalz",
          url: "http://www.verkehr.rlp.de",
          img_src: require("@/assets/images/partner/rheinland_pfalz_mobiportal.png")
        }
      ]
    };
  },
  computed: {
    device() {
      return this.$store.state.device;
    }
  },
  methods: {
    closeSidebar() {
      this.$emit("close");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.partnerContainer {
  width: 100%;
  height: 100%;
}

.partnerContent {
  height: calc(100% - 62.4px);
  width: 100%;
  overflow-y: auto;
}

.partnerListe {
  display: flex;
  flex-wrap: wrap;
}

.partnerItem {
  width: 48%;
  margin-right: 4%;
  border: thin solid #e1e1e1;
  text-align: center;
  overflow: hidden;
  margin-bottom: 20px;
  padding: 5px;
  min-height: 140px;
  color: #2f58a7 !important;
}
.partnerItem:nth-child(even) {
  margin-right: 0%;
}
.partnerItem img {
  width: 100%;
  height: auto;
}
</style>
